import ProfileForm from "./ProfileForm";
import { Profile } from "../profileTypes";

interface Props {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setExpandedIds: any;
  profiles: Profile[];
  refetch: (
    params?:
      | Omit<
          {
            clientId: string;
          },
          "clientId"
        >
      | undefined
  ) => Promise<void>;
  currentProfile?: Profile;
}

const NewProfile = ({ setIsModalOpen, profiles, refetch, setExpandedIds }: Props) => {
  return (
    <ProfileForm
      setIsModalOpen={setIsModalOpen}
      profiles={profiles}
      refetch={refetch}
      isEditMode={false}
      setExpandedIds={setExpandedIds}
    />
  );
};

export default NewProfile;
